import {OPTION_LABELS} from '@/constants/search/filter';
import FilterOption from './FilterOption';

/**
 * FilterGroup 컴포넌트
 * @param {Object} filterGroup - 필터 그룹 정보 (key, title, options 포함)
 * @param {string} tagname - 태그 검색 시 사용되는 태그명
 * @param {React.RefObject} calenderRef - 달력 ref
 * @param {Object} dateRange - 선택된 날짜 범위 {startDate: string, endDate: string}
 * @param {Function} getOptionClass - 옵션의 클래스명을 반환하는 함수 (option) => string
 * @param {Function} handleDirectInput - 직접입력 클릭 핸들러
 * @param {Function} handleOptionSelect - 옵션 선택 핸들러
 * @param {Function} handleDateSelected - 날짜 선택 핸들러
 */
const FilterGroup = ({
  filterGroup,
  tagname,
  calenderRef,
  dateRange,
  getOptionClass,
  handleDirectInput,
  handleOptionSelect,
  handleDateSelected,
}) => {
  const shouldRenderOption = (option) =>
    !(tagname && option.label === OPTION_LABELS.PLAYLIST);

  return (
    <dl key={`${filterGroup.key}`}>
      <dt>{filterGroup.title}</dt>
      <dd>
        <ul>
          {filterGroup.options
            .filter(shouldRenderOption)
            .map((option, optionIndex) => (
              <FilterOption
                key={optionIndex}
                option={option}
                optionIndex={optionIndex}
                filterGroup={filterGroup}
                calenderRef={calenderRef}
                dateRange={dateRange}
                getOptionClass={getOptionClass}
                handleDirectInput={handleDirectInput}
                handleOptionSelect={handleOptionSelect}
                handleDateSelected={handleDateSelected}
              />
            ))}
        </ul>
      </dd>
    </dl>
  );
};

export default FilterGroup;
